<template>
<div id="deposit-02">
    <div class="container pr-4 pl-4 pt-5">
        <div class="row">
            <div class="col number-bullet-lg-width-flex">
                <div class="number-bullet-lg rounded-circle d-flex align-items-center justify-content-center bg-primary-dimmed">
                    <p class="h4 font-weight-normal m-0 text-primary">1</p>
                </div>
            </div>
            <div class="col pl-0 d-flex align-items-center">
                <p class="h3 font-weight-normal m-0">ระบุจำนวนเงินที่เติม<br><span class="h6">ยอดฝากขั้นต่ำ 500 บาท</span></p>
            </div>
        </div>
        <div class="row pt-4">
            <div class="col">
                <div class="form-group form-goobank">
                    <input :class="{'disabled': isProcessing}" class="form-control text-center form-control-cta input-decimal-mask-goobank" name="amount" type="number" v-model.number="amount" />
                </div>
                <div class="row pt-4" v-if="!isValidMoney() && suitableToShowWarning">
                    <div class="col number-bullet-xl-width-flex">
                        <div class="number-bullet-xl rounded-circle d-flex align-items-center justify-content-center bg-danger-dimmed">
                            <p class="h3 font-weight-normal m-0 text-danger">!</p>
                        </div>
                    </div>
                    <div class="col pl-0 d-flex align-items-center">
                        <p class="text-danger m-0">โปรดเลือกจำนวนเงินที่ไม่มีทศนิยมและเป็นจำนวนที่มากกว่า 500</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="stick-down-pusher"></div>
    <div class="stick-down p-4">
        <p v-if="isPendingProcess" class="text-center text-danger mb-2">รายการฝากเดิมกำลังถูกดำเนินการอยู่ รายการเก่าจะถูกดำเนินการภายใน 24 ชั่วโมง กรุณาลองใหม่อีกครั้งหลังจากนั้น</p>
        <button @click="requestDeposit()" :disabled="!isValidMoney() || amount < 1 || isProcessing" class="btn btn-primary btn-lg btn-block">
            ดำเนินการต่อ
        </button>
        <router-link class="btn btn-light btn-lg btn-block" :to="{ name: 'deposit-01' }">ย้อนกลับ</router-link>
    </div>
</div>
</template>

<script>
export default {
    data: () => ({
        isProcessing: false,
        isPendingProcess: false,
        suitableToShowWarning: false,
        amount: ''
    }),
    methods: {
        isValidMoney () {
            if (this.amount % 1 != 0 || this.amount < 500) { // not whole number or negative
                return false
            }
            return true
        },
        async requestDeposit () {
            this.suitableToShowWarning = true
            this.isProcessing = true
            try {
                const result = await this.$api.deposit.request(this.amount)
                const data = result.data
                if (data.success) {
                    this.$router.replace({ name: 'deposit-03' })
                } else {
                    this.isPendingProcess = true
                }
            } catch (err) {
                console.error(err)
            }
        }
    }
}
</script>

<style>
</style>
